<template>
	<div class="form-group clearfix">
		<div
			:class="{'float-left': (field.labelStyle=='justify'||field.labelStyle=='inline')}"
		>
			<label v-if="field.question" class="mr-2 align-top" :for="field.id">{{ field.question }}</label>
			<div v-if="field.description" v-html="field.description" class="mr-2"></div>
		</div>
		<input
			type="number"
			class="form-control"
			v-model="field.value"
			:id="field.id"
			:aria-label="field.question"
			:class="{'float-right': (field.labelStyle=='justify')}"
			v-bind:style="{ 'display': (field.labelStyle=='justify'||field.labelStyle=='inline'?'inline':''), 'width': (field.labelStyle=='justify'||field.labelStyle=='inline'?'auto':'') }"
			placeholder=""
			:readonly="readonly"
		>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly']
};
</script>
